import { Pipe, PipeTransform } from '@angular/core';

// Available credit in whole dollars, rounded down: 3500.99 -> $3,500. A negative or missing amount shows as $0.
@Pipe({
    name: 'creditAmount',
    standalone: true
})
export class CreditAmountPipe implements PipeTransform {
  transform(value: number): string {
    return '$' + Math.max(Math.floor(value ?? 0), 0).toLocaleString('en-US');
  }
}
